export const AUTH = "/auth";
export const PUBLIC_VISIT = "/visit";
export const QUESTIONNAIRE = "/questionnaire";
export const ORDER_PAGE = "/order/:token";
export const PUBLIC_CLINIC_PAGE = "/clinic/:clinicSlug";
export const PUBLIC_CLINIC_BOOKING = "/clinic/:clinicSlug/book";
export const PUBLIC_PRODUCT_PAGE = "/product/:productSlug";
export const REJESTRACJA = `/rejestracja`;

export const PASSWORD_RESET = "/auth/reset-password";
export const PASSWORD_RESET_SUCCESS = "/auth/reset-password/success";
export const PATIENT_PASSWORD_RESET = "/auth/patient/reset-password";
export const PASSWORD_STORE = "/auth/store-password";
export const PASSWORD_STORE_SUCCESS = "/auth/store-password/success";
export const PATIENT_PASSWORD_STORE = "/auth/patient/store-password";
export const PASSWORD_REMIND = "/auth/remind-password";
export const REGISTER_NEW = "/auth/register";
export const REGISTER_SUCCESS = "/auth/register/success";
export const REGISTER_GOOGLE = "/auth/register/google";
export const LOGIN = `/auth/login`;
export const OAUTH_GOOGLE_LOGIN_CLINICS = "/oauth/google/login/clinics";
export const LOGIN_SELECT_ACCOUNT = `/auth/login/select-account`;
export const LOGIN_TWO_FACTOR = `/auth/login/two-factor`;
export const LOGIN_GOOGLE_NO_ACCOUNT_ERROR = `/auth/login/google`;

export const ACTIVATION = `${AUTH}/activation`;
export const LINK_RESEND = `${AUTH}/resend`;
export const RETRIEVE = `${AUTH}/retrieve`;

export const CHAT_MAIN = "/chat";
export const CHAT = `${CHAT_MAIN}/:conversationId`;

export const REGISTER = `${AUTH}/secret_registration_page`;
export const REGISTER_CLINIC = `${AUTH}/registration`;
export const REGISTER_PATIENT = `${AUTH}/register/patient`;

export const VISIT_CONFIRM = `${PUBLIC_VISIT}/confirm`;
export const VISIT_CANCEL = `${PUBLIC_VISIT}/cancel`;

export const DASHBOARD = "/";
export const ONBOARDING = "/onboarding";

export const CALENDAR = `${DASHBOARD}calendar`;

export const SETTINGS = `${DASHBOARD}settings`;
export const SETTINGS_SCHEDULE = `${SETTINGS}/schedule`;

export const DIETICIAN_SETTINGS = `${DASHBOARD}dietician-settings`;
export const DIETICIAN_SETTINGS_GENERAL = `${DIETICIAN_SETTINGS}/general`;
export const DIETICIAN_SETTINGS_OFFICES = `${DIETICIAN_SETTINGS}/offices`;
export const DIETICIAN_SETTINGS_EMPLOYEES = `${DIETICIAN_SETTINGS}/employees`;
export const DIETICIAN_SETTINGS_PRODUCTS = `${DIETICIAN_SETTINGS}/products`;
export const DIETICIAN_SETTINGS_KEYS = `${DIETICIAN_SETTINGS}/keys`;
export const DIETICIAN_SETTINGS_ONLINE_PAYMENTS = `${DIETICIAN_SETTINGS}/online-payments`;
export const PLANS_AND_PAYMENTS = `${DIETICIAN_SETTINGS}/plans-and-payments`;
export const PLANS_AND_PAYMENTS_INVOICES = `${PLANS_AND_PAYMENTS}/invoices`;

export const COOPERATION_SETTINGS = `${DASHBOARD}cooperation-settings`;

export const PATIENTS = `${DASHBOARD}patients`;

export const CLIENT = `${PATIENTS}/:patientId`;
export const PATIENT_ENERGY_BALANCE_BASE = `${CLIENT}/balance`;
export const PATIENT_ENERGY_BALANCE = `${PATIENT_ENERGY_BALANCE_BASE}/*`;
export const HEALTH_AND_GOALS_VIEW = `${CLIENT}/health-and-goals`;
export const INFO_AND_SERVICES_VIEW = `${CLIENT}/info-and-services`;
export const APPOINTMENTS_VIEW = `${CLIENT}/appointments`;
export const ENERGY_BALANCE_BASE = `${CLIENT}/energy-balance`;
export const ENERGY_BALANCE_VIEW = `${ENERGY_BALANCE_BASE}/*`;
export const CLIENT_PROGRAMS_NEW = `${CLIENT}/programs`;
export const QUESTIONNAIRE_ANSWERS = `${CLIENT}/questionnaire/:questionnaireId`;
export const PATIENT_AI_NOTES = `${CLIENT}/bite`;
export const PATIENT_FILES = `${CLIENT}/files`;
export const PATIENT_MONITORING = `${CLIENT}/monitoring`;
export const PATIENT_MONITORING_DAY = `${CLIENT}/monitoring/day/:day`;
export const PATIENT_MONITORING_WEEK = `${CLIENT}/monitoring/week/:week`;
export const PATIENT_MONITORING_MONTH = `${CLIENT}/monitoring/month/:month`;
export const PATIENT_MONITORING_CUSTOM = `${CLIENT}/monitoring/custom/:from/:to`;
export const PATIENT_CHOICE_PROGRAM = `${CLIENT}/programs/choice`;
export const PATIENT_START_PROGRAM = `${CLIENT}/programs/start`;
export const PATIENT_SHARED = `${CLIENT}/shared`;
export const PATIENT_SHARED_COLLECTIONS = `${PATIENT_SHARED}/collections`;
export const PATIENT_SHARED_DIETS = `${PATIENT_SHARED}/diets`;
export const PATIENT_SHARED_RECIPES = `${PATIENT_SHARED}/recipes`;
export const PATIENT_SHARED_EDUCATIONAL_MATERIALS = `${PATIENT_SHARED}/educationalMaterials`;
export const PATIENT_SHARED_EDUCATIONAL_MATERIALS_TEXT = `${PATIENT_SHARED_EDUCATIONAL_MATERIALS}/text`;
export const PATIENT_SHARED_EDUCATIONAL_MATERIALS_VIDEO = `${PATIENT_SHARED_EDUCATIONAL_MATERIALS}/video`;
export const PATIENT_SHARED_EDUCATIONAL_MATERIALS_PDF = `${PATIENT_SHARED_EDUCATIONAL_MATERIALS}/pdf`;
export const PATIENT_NEW_PROGRAM = `${CLIENT}/nutritional-programs/new`;
export const PATIENT_PROGRAM = `${CLIENT}/nutritional-programs/:programId`;
export const PATIENT_PROGRAM_EDIT = `${PATIENT_PROGRAM}/edit`;
export const PATIENT_PROGRAM_DAYS = `${PATIENT_PROGRAM}/days`;
export const PATIENT_PROGRAM_DAYS_ALL = `${PATIENT_PROGRAM}/days/*`;
export const PATIENT_PROGRAM_DAY = `${PATIENT_PROGRAM_DAYS}/:dayId`;
const PATIENT_PROGRAM_DAY_DIET = `${PATIENT_PROGRAM_DAY}/diet`;
export const PATIENT_PROGRAM_DAY_DIET_EDIT = `${PATIENT_PROGRAM_DAY}/diet/:dietId/edit`;
export const PATIENT_PROGRAM_DAY_DIET_NEW = `${PATIENT_PROGRAM_DAY_DIET}/new`;
export const PATIENT_PROGRAM_SCHEDULE = `${PATIENT_PROGRAM}/schedule`;
export const PATIENT_PROGRAM_SCHEDULE_RECIPE_EDIT = `${PATIENT_PROGRAM_SCHEDULE}/day/:dayId/meal/:mealId/edit`;

export const PATIENT_PROGRAM_DAY_DIET_EDIT_SETTINGS = `${PATIENT_PROGRAM_DAY_DIET_EDIT}/settings`;
export const PATIENT_PROGRAM_DAY_DIET_EDIT_RECIPES = `${PATIENT_PROGRAM_DAY_DIET_EDIT}/recipes`;
export const PATIENT_PROGRAM_DAY_DIET_EDIT_PRODUCTS = `${PATIENT_PROGRAM_DAY_DIET_EDIT}/products`;
export const PATIENT_PROGRAM_DAY_DIET_EDIT_TAGS = `${PATIENT_PROGRAM_DAY_DIET_EDIT}/tags`;

export const PATIENT_PROGRAM_EDIT_SETTINGS = `${PATIENT_PROGRAM_EDIT}/settings`;
export const PATIENT_PROGRAM_EDIT_ASSUMPTIONS = `${PATIENT_PROGRAM_EDIT}/assumptions`;
export const PATIENT_PROGRAM_EDIT_RECIPES = `${PATIENT_PROGRAM_EDIT}/recipes`;
export const PATIENT_PROGRAM_EDIT_MEAL_PLAN = `${PATIENT_PROGRAM_EDIT}/meal-plan`;
export const PATIENT_PROGRAM_EDIT_SCHEDULE = `${PATIENT_PROGRAM_EDIT}/schedule`;

export const PRODUCTS = `${DASHBOARD}products`;
export const PRODUCT = `${PRODUCTS}/:productId`;
export const NEW_PRODUCT = `${PRODUCTS}/new`;
export const EDIT_PRODUCT = `${PRODUCT}/edit`;
export const CLONE_PRODUCT = `${PRODUCT}/copy`;

export const RECIPES = `${DASHBOARD}recipes`;
export const RECIPE = `${RECIPES}/:recipeId`;
export const NEW_RECIPE = `${RECIPES}/new`;
export const EDIT_RECIPE = `${RECIPE}/edit`;
export const COPY_RECIPE = `${RECIPE}/copy`;

export const MEAL = `${DASHBOARD}meals/:mealId`;
export const MEALS = `${DASHBOARD}meals`;
export const MEAL_NEW = `${MEALS}/new`;
export const MEAL_EDIT = `${MEALS}/:mealId/edit`;
export const MEAL_COPY = `${MEALS}/:mealId/copy`;

export const DIETS = `${DASHBOARD}diets`;
export const DIET = `${DIETS}/:dietId`;
export const COPY_DIET = `${DIET}/copy`;
export const EDIT_DIET = `${DIET}/edit`;
export const EDIT_DIET_SETTINGS = `${EDIT_DIET}/settings`;
export const EDIT_DIET_RECIPES = `${EDIT_DIET}/recipes`;
export const EDIT_DIET_PRODUCTS = `${EDIT_DIET}/products`;
export const EDIT_DIET_TAGS = `${EDIT_DIET}/tags`;

export const PROGRAMS = `${DASHBOARD}programs`;
export const PROGRAM = `${PROGRAMS}/:programId`;
export const PROGRAM_EDIT = `${PROGRAM}/edit`;
export const PROGRAM_EDIT_SETTINGS = `${PROGRAM_EDIT}/settings`;
export const PROGRAM_EDIT_ASSUMPTIONS = `${PROGRAM_EDIT}/assumptions`;
export const PROGRAM_EDIT_RECIPES = `${PROGRAM_EDIT}/recipes`;
export const PROGRAM_EDIT_MEAL_PLAN = `${PROGRAM_EDIT}/meal-plan`;
export const PROGRAM_EDIT_SCHEDULE = `${PROGRAM_EDIT}/schedule`;
export const PROGRAM_COPY = `${PROGRAM}/copy`;
export const PROGRAM_NEW = `${PROGRAMS}/new`;
export const PROGRAM_DAYS_ALL = `${PROGRAM}/days/*`;
export const PROGRAM_DAYS = `${PROGRAM}/days`;
export const PROGRAM_DAY = `${PROGRAM_DAYS}/:dayId`;
export const PROGRAM_SCHEDULE = `${PROGRAM}/schedule`;
export const PROGRAM_SCHEDULE_RECIPE_EDIT = `${PROGRAM_SCHEDULE}/day/:dayId/meal/:mealId/edit`;

export const PROGRAM_DIET_NEW = `${PROGRAM_DAYS}/:dayId/diet/new`;
export const PROGRAM_DIET_EDIT = `${PROGRAM_DAYS}/:dayId/diet/:dietId/edit`;

export const PROGRAM_DIET_EDIT_SETTINGS = `${PROGRAM_DIET_EDIT}/settings`;
export const PROGRAM_DIET_EDIT_RECIPES = `${PROGRAM_DIET_EDIT}/recipes`;
export const PROGRAM_DIET_EDIT_PRODUCTS = `${PROGRAM_DIET_EDIT}/products`;
export const PROGRAM_DIET_EDIT_TAGS = `${PROGRAM_DIET_EDIT}/tags`;

export const SECTIONS = `${DASHBOARD}sections`;
export const SECTION = `${SECTIONS}/:sectionId`;

export const TASKS = `${DASHBOARD}tasks`;
export const TASKS_NOTES = `${TASKS}/notes`;

export const QUESTIONNAIRES = `${DASHBOARD}questionnaires`;
export const QUESTIONNAIRE_EDIT = `${QUESTIONNAIRES}/:questionnaireId/edit`;

export const SALES_PRODUCTS = `${DASHBOARD}sales/products`;
export const SALES_PRODUCT_NEW = `${SALES_PRODUCTS}/new`;
export const SALES_PRODUCT = `${SALES_PRODUCTS}/:productId`;
export const SALES_STOREFRONT = `${DASHBOARD}sales/storefront`;
export const SALES_PURCHASES = `${DASHBOARD}sales/purchases`;

export const ACCOUNT_SETTINGS = `${DASHBOARD}account`;
export const ACCOUNT_SCHEDULE = `${ACCOUNT_SETTINGS}/schedule`;
export const ACCOUNT_INTEGRATIONS = `${ACCOUNT_SETTINGS}/integrations`;
export const ACCOUNT_SECURITY = `${ACCOUNT_SETTINGS}/security`;
export const ACCOUNT_PREFERENCES = `${ACCOUNT_SETTINGS}/preferences`;
export const CLINIC_SETTINGS = `${DASHBOARD}clinic-settings`;
export const CLINIC_SETTINGS_SELLER = `${CLINIC_SETTINGS}#seller`;
export const CLINIC_SETTINGS_BRAND = `${CLINIC_SETTINGS}#brand`;
export const CLINIC_SETTINGS_SOCIAL = `${CLINIC_SETTINGS}#social`;
export const CLINIC_SETTINGS_OFFICES = `${CLINIC_SETTINGS}/offices`;
export const CLINIC_SETTINGS_TEAM = `${CLINIC_SETTINGS}/team`;
export const CLINIC_SETTINGS_PAYMENTS = `${CLINIC_SETTINGS}/payments`;
export const CLINIC_SETTINGS_BILLING = `${CLINIC_SETTINGS}/billing`;
export const CLINIC_SETTINGS_COOPERATION = `${CLINIC_SETTINGS}/cooperation`;
export const CLINIC_SETTINGS_PLAN = `${CLINIC_SETTINGS}/plan`;
export const CLINIC_SETTINGS_PLAN_INVOICES = `${CLINIC_SETTINGS_PLAN}/invoices`;
export const CLINIC_SETTINGS_API_KEYS = `${CLINIC_SETTINGS}/api-keys`;

export const INTEGRATIONS = `${DASHBOARD}integrations`;
export const GOOGLE_CALLBACK = `${DASHBOARD}oauth/google/callback`;

export const MAINTENANCE = `${DASHBOARD}maintenance`;
export const PRICING = `${DASHBOARD}pricing`;
export const PRICING_CONFIGURE = `${DASHBOARD}pricing/configure`;
export const PRICING_SERVICE_CONFIGURE = `${DASHBOARD}pricing/configure-service/:serviceId`;
export const YOUR_PLAN = `${DASHBOARD}your-plan`;
